exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".events-bwrewards-component__content-holder{color:#172660;padding:0 16px 16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/events/bwrewards.scss
// module id = 1018
// module chunks = 0